function normalizeText(value) {
  const raw = String(value || "");
  const normalized = typeof raw.normalize === "function" ? raw.normalize("NFD") : raw;
  return normalized
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();
}

function applyFilter(container, term) {
  const items = container.querySelectorAll("[data-feature-item]");
  const groups = container.querySelectorAll("[data-feature-group]");
  const normalizedTerm = normalizeText(term);

  items.forEach((item) => {
    const text = normalizeText(item.dataset.featureSearchText);
    const visible = normalizedTerm === "" || text.includes(normalizedTerm);
    item.classList.toggle("d-none", !visible);
  });

  let visibleGroups = 0;
  groups.forEach((group) => {
    const hasVisibleItem = group.querySelector("[data-feature-item]:not(.d-none)");
    group.classList.toggle("d-none", !hasVisibleItem);
    visibleGroups += hasVisibleItem ? 1 : 0;
  });

  const emptyState = container.querySelector("[data-feature-search-empty]");
  if (emptyState) {
    const hasFilterText = normalizedTerm.length > 0;
    const shouldShowEmpty = items.length > 0 && visibleGroups === 0 && hasFilterText;
    emptyState.classList.toggle("d-none", !shouldShowEmpty);
  }
}

export function initProfileFeatureSearch() {
  document.querySelectorAll("[data-feature-search]").forEach((container) => {
    if (container.dataset.featureSearchInitialized === "1") {
      return;
    }

    const input = container.querySelector("[data-feature-search-input]");
    if (!input) {
      return;
    }

    container.dataset.featureSearchInitialized = "1";

    const runFilter = () => applyFilter(container, input.value);
    input.addEventListener("input", runFilter);
    input.addEventListener("search", runFilter);
    runFilter();
  });
}
